import React from 'react';
import type { IconProps } from '../../types';

export const EmailIcon: React.FC<IconProps> = ({
  className = '',
  width = 7,
  height = 5,
  fill = 'currentColor',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 7 5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M6.36567 0.771162C6.36567 0.465724 6.11577 0.21582 5.81033 0.21582H1.3676C1.06216 0.21582 0.812256 0.465724 0.812256 0.771162V4.10321C0.812256 4.40865 1.06216 4.65855 1.3676 4.65855H5.81033C6.11577 4.65855 6.36567 4.40865 6.36567 4.10321V0.771162ZM5.81033 0.771162L3.58896 2.15951L1.3676 0.771162H5.81033ZM5.81033 4.10321H1.3676V1.3265L3.58896 2.71486L5.81033 1.3265V4.10321Z'
        fill={fill}
      />
    </svg>
  );
};
